<template>
  <div class="content_main">
    <div class="content_main_top">
      <a-button type="primary" @click="show_apply"> 合同审批 </a-button>
      <a-button type="primary"> 数据导出 </a-button>
    </div>
    <div class="content_main_top">
      <a-input
        allowClear
        class="a_input_self margin_self"
        v-model="query.contractCode"
        placeholder="审批编号"
        @keyup.enter.native="serchQuery"
      />
      <a-range-picker
        valueFormat="YYYY-MM-DD"
        style="margin-right: 10px; width: 240px"
        allowClear
        :value="dates"
        @change="onChange"
        @keyup.enter.native="serchQuery"
        :placeholder="['申请开始时间', '申请结束时间']"
      />
      <a-input
        allowClear
        class="a_input_self margin_self"
        v-model="query.createByName"
        placeholder="申请人"
        @keyup.enter.native="serchQuery"
      />
      <a-select
        allowClear
        placeholder="审批结果"
        v-model="query.result"
        class="margin_self a_select_self"
        @keyup.enter.native="serchQuery"
      >
        <a-select-option :value="index" v-for="(item, index) in result_apply" :key="index">
          {{ item.txt }}
        </a-select-option>
      </a-select>
      <a-select
        allowClear
        placeholder="审批状态"
        v-model="query.status"
        class="margin_self a_select_self"
        @keyup.enter.native="serchQuery"
      >
        <a-select-option :value="index" v-for="(item, index) in status_apply" :key="index">
          {{ item.txt }}
        </a-select-option>
      </a-select>
      <a-button type="primary" @click="serchQuery"> 查询 </a-button>
      <a-button type="primary" ghost @click="reset"> 重置 </a-button>
    </div>
    <div class="content_main_center" id="content_main_center_scroll" style="height:calc(100% - 100)">
      <a-table
        :data-source="lis"
        bordered
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true }"
      >
        <a-table-column key="index" title="序号" data-index="index" width="70px">
          <template scope="text, record, index">{{
            (pagination.current - 1) * pagination.pageSize + index + 1
          }}</template>
        </a-table-column>
        <a-table-column key="applyCode" title="审批编号" data-index="applyCode" />
        <a-table-column key="title" title="标题" data-index="title" />
        <a-table-column key="contractCode" title="合同编号" data-index="contractCode" />
        <a-table-column key="createByName" title="申请人" data-index="createByName" />
        <a-table-column key="createTime" title="申请时间" data-index="createTime" />
        <a-table-column key="result" title="审批结果" data-index="result">
          <template scope="text">
            <a-tag :color="result_apply[text].color">
              {{ result_apply[text].txt }}
            </a-tag>
            <span></span>
          </template>
        </a-table-column>
        <a-table-column key="status" title="审批状态" data-index="status">
          <template scope="text">
            <a-tag :color="status_apply[text].color">
              {{ status_apply[text].txt }}
            </a-tag>
            <span></span>
          </template>
        </a-table-column>
        <a-table-column title="详情" width="170px">
          <template scope="text,record">
            <a @click="show_details(record)">详情</a>
            <a-divider type="vertical" />
            <a @click="handFlow(record)">历史</a>
            <a-divider type="vertical" />
            <a :disabled="record.status !== 1" @click="cancel([record.procInstId])">撤销</a>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
      title="新增合同审批"
      :visible="is_show_apply"
      @cancel="is_show_apply = false"
      width="70%"
      :maskClosable="false"
    >
      <template slot="footer">
        <a-button key="back" @click="is_show_apply = false"> 取消 </a-button>
        <a-button key="submit" type="primary" @click="handleOk"> 提交 </a-button>
      </template>
      <a-form-model :model="form" ref="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-row>
          <a-form-item label="选择抄送人" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <ccChange :data="ccC" :money="moneY" @targetKeys="getdata" v-if="isRouterAlive" />
          </a-form-item>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="审批编号">
              <a-input v-model="form.applyCode" disabled></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="合同编号" prop="contractCode">
              <a-input v-model="form.contractCode" allowClear placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="合同名称" prop="contractName">
              <a-input v-model="form.contractName" allowClear placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="客户名称" prop="customerName">
              <a-input v-model="form.customerName" allowClear placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="合同日期" prop="contractDate">
              <a-date-picker
                valueFormat="YYYY-MM-DD"
                style="width: 267px"
                allowClear
                v-model="form.contractDate"
                placeholder="请输入"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="项目名称" prop="projectName">
              <a-input v-model="form.projectName" allowClear placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="项目编号" prop="projectCode">
              <a-input v-model="form.projectCode" allowClear placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="到期日期" prop="expiryDate">
              <a-date-picker
                valueFormat="YYYY-MM-DD"
                style="width: 267px"
                allowClear
                v-model="form.expiryDate"
                placeholder="请选择"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="合同金额(元)" prop="contractAmount">
              <a-input
                v-model="form.contractAmount"
                @input="contractAmountchange"
                allowClear
                placeholder="请输入"
                oninput="value=value.replace(/[^\d.]/g,'')"
              ></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="客户联系人" prop="customerContact">
              <a-input v-model="form.customerContact" allowClear placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="联系方式" prop="contactInformation">
              <a-input v-model="form.contactInformation" allowClear placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="跟进人部门" prop="followerDept">
              <a-tree-select
                allowClear
                :treeData="deptTree"
                placeholder="请输入"
                @change="onChangeDept"
                treeDefaultExpandAll
              >
              </a-tree-select>
              <!-- <a-cascader :options="options" placeholder="请选择" @change="onChangeDept" /> -->
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="跟进人" prop="follower">
              <a-select
                style="width: 100%"
                :disabled="!form.followerDept"
                allowClear
                v-model="form.follower"
                placeholder="请选择"
              >
                <a-select-option :value="item.value" v-for="(item, index) in followers" :key="index">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="8">
						<a-form-model-item label="抄送人部门">
							<a-cascader :options="options" placeholder="请选择" @change="onChangeDeptCc" />
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="抄送人" prop="ccIds">
							<a-select mode="multiple" v-model="form.ccIds" style="width: 100%" :disabled="!form.ccDeptId" placeholder="请选择"
							 allowClear @change="handleChange">
								<a-select-option v-for="(item, index) in ccs" :value="item.value" :key="index">
									{{ item.label }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col> -->
          <a-col :span="8">
            <a-form-model-item label="图片">
              <uploadImgJava :data="uploadDataImg" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="附件">
              <uploadFileCode :data="uploadData" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
    <!-- 撤销提示 -->
    <a-modal v-model="is_revocation" title="确认撤销此申请吗?" on-ok="handleOkReason">
      <template slot="footer">
        <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason"> 撤销 </a-button>
      </template>
      <a-textarea placeholder="请输入原因" v-model="reason" />
    </a-modal>
    <!-- 详情 -->
    <contractModal ref="contractmodal" :audit="false" />
    <proc-flow-modal ref="modalflow" @ok="handleOk" />
  </div>
</template>
<script>
import { getDeptListEnable2 } from '@/api/system'
import { returnDept2, get_users2, get_dict } from '@/utils/unit_axios'
import { contract_apply_save, contract_apply_list, contract_apply_code } from '@/api/financial'
import uploadFileCode from '@/components/module/uploadFileCode.vue'
import uploadImgJava from '@/components/module/uploadImgJava.vue'
import { modalMap, delProcessIns } from '@/api/activiti'
import contractModal from '@/views/activiti/modules/contractModal.vue'
import ProcFlowModal from '../activiti/modules/ProcFlowModal.vue' //历史
import ccChange from '@/components/module/ccChange'
export default {
  components: {
    uploadFileCode,
    uploadImgJava,
    contractModal,
    ProcFlowModal,
    ccChange,
  },
  data() {
    return {
      deptTree: [],
      scroll_y: 150,
      ccC: 'contract_ys',
      moneY: '',
      isRouterAlive: true,
      loading: false,
      is_revocation: false,
      tabid: '',
      reason: '',
      options: [], //部门
      followers: [], //跟进人列表
      ccs: [], //抄送人
      lis: [],
      query: {
        contractCode: '',
        createTime1: '', // 申请时间 createTime1 :'',//
        result: undefined, //  审批状态
        status: undefined,
        createByName: '', //申请人
      },
      uploadData: {
        code: '',
        type: 'contract-file',
        // types: ['application/pdf'],
      },
      uploadDataImg: {
        code: '',
        type: 'contract-img',
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      labelCol: {
        span: 9,
      },
      wrapperCol: {
        span: 15,
      },
      is_show_apply: false,
      form: {
        // cc: '', //	抄送人
        // ccIds: [],
        // ccDeptId: '', //抄送人部门id
        cc: [],
        applyCode: '', //审批编号
        contractCode: '', //	合同编号
        contractName: '', //	合同名称
        customerName: '', //	客户名称
        contractDate: '', //	合同日期
        projectName: '', //	项目名称
        projectCode: '', //项目编号
        expiryDate: '', //	到期日期
        contractAmount: '', //	合同金额;元）
        customerContact: '', //客户联系人
        contactInformation: '', //	联系方式
        follower: undefined, //	跟进人
        followerDept: '', //	跟进人部门
      },
      labelCol2: {
        span: 2,
      },
      wrapperCol2: {
        span: 22,
      },
      dates: [],
      rules: {
        contractCode: [
          {
            required: true,
            message: '请填写合同编号',
            trigger: 'blur',
          },
        ],
        contractName: [
          {
            required: true,
            message: '请填写合同名称',
            trigger: 'blur',
          },
        ],
        customerName: [
          {
            required: true,
            message: '请填写客户名称',
            trigger: 'blur',
          },
        ],
        contractDate: [
          {
            required: true,
            message: '请选择合同日期',
            trigger: 'change',
          },
        ],
        projectName: [
          {
            required: true,
            message: '请填写项目名称',
            trigger: 'blur',
          },
        ],
        projectCode: [
          {
            required: true,
            message: '请填写项目编号',
            trigger: 'blur',
          },
        ],
        expiryDate: [
          {
            required: true,
            message: '请选择到期日期',
            trigger: 'change',
          },
        ],
        contractAmount: [
          {
            required: true,
            message: '请填写合同金额',
            trigger: 'blur',
          },
        ],
        customerContact: [
          {
            required: true,
            message: '请填写客户联系人',
            trigger: 'blur',
          },
        ],
        follower: [
          {
            required: true,
            message: '请选择跟进人',
            trigger: 'change',
          },
        ],
        followerDept: [
          {
            required: true,
            message: '请选择跟进人部门',
            trigger: 'change',
          },
        ],
        ccIds: [
          {
            required: true,
            message: '请选择抄送人',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.get_lis()
    returnDept2((res) => {
      this.options = res.depts
    })
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height()-50
      }, 1000)
    })
    getDeptListEnable2().then((res) => {
      const data = res.rows
      if (data.length > 0) {
        const min = Math.min(...data.map((m) => m.parentId))
        this.buildtree2(data, this.deptTree, min)
      }
    })
  },
  methods: {
    buildtree2(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree2(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    contractAmountchange() {
      this.moneY = this.form.contractAmount
    },
    handFlow(row) {
      var obj = {
        procInstId: row.procInstId,
        procDefKey: row.procDefKey,
      }
      this.$refs.modalflow.show(obj)
    },
    onChange(date, dateString) {
      this.dates = date
      this.query.createTime1 = date[0]
      this.query.createTime2 = date[1]
    },
    getdata(data) {
      this.form.cc = data
    },
    //选择跟进人部门
    onChangeDept(value) {
      this.followers = []
      this.form.followerDept = value
      get_users2(value, (res) => {
        this.form.follower = undefined
        res.forEach((item) => {
          item['label'] = item.userName
          item['value'] = item.userId
        })
        this.followers = res
      })
    },
    //选择抄送人部门
    onChangeDeptCc(value) {
      this.ccs = []
      this.form.ccDeptId = value[1]
      get_users2(value[1], (res) => {
        this.form.ccIds = []
        console.log(res)
        res.forEach((item) => {
          item['label'] = item.userName
          item['value'] = item.userId
        })
        this.ccs = res
      })
    },
    serchQuery() {
      this.pagination.current = 1
      this.get_lis()
    },
    //重置
    reset() {
      this.query = {}
      this.dates = []
    },
    //改变分页
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.loading = true
      this.get_lis()
    },
    get_lis() {
      contract_apply_list({
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        createByName: this.query.createByName,
        result: this.query.result,
        status: this.query.status,
        createTime1: this.query.createTime1,
        createTime2: this.query.createTime2,
        applyCode: this.query.contractCode,
      }).then((res) => {
        const pagination = { ...this.pagination }
        pagination.total = res.total
        this.pagination = pagination
        this.loading = false
        this.lis = res.rows
      })
    },
    //点击合同审批
    show_apply() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
      ;(this.form = {
        // cc: '', //	抄送人
        // ccIds: [],
        // ccDeptId: '', //抄送人部门id
        cc: [],
        applyCode: '', //审批编号
        contractCode: '', //	合同编号
        contractName: '', //	合同名称
        customerName: '', //	客户名称
        contractDate: '', //	合同日期
        projectName: '', //	项目名称
        projectCode: '', //项目编号
        expiryDate: '', //	到期日期
        contractAmount: '', //	合同金额;元）
        customerContact: '', //客户联系人
        contactInformation: '', //	联系方式
        follower: undefined, //	跟进人
        followerDept: '', //	跟进人部门
      }),
        contract_apply_code().then((res) => {
          this.uploadData.code = res.data
          this.uploadDataImg.code = res.data
          this.form.applyCode = res.data
          this.is_show_apply = true
        })
    },
    //提交
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.form.cc = this.form.cc.length ? this.form.cc.join(',') : ''
          contract_apply_save(this.form).then((res) => {
            if (res.code != 200) {
              this.$message.error(res.msg)
              return
            }
            this.$message.success('提交成功')
            this.is_show_apply = false
            this.get_lis()
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 撤销
    cancel(ids) {
      this.is_revocation = true
      this.tabid = ids
      this.reason = ''
    },
    //撤销提交
    handleOkReason() {
      delProcessIns({
        ids: this.tabid.join(','),
        reason: this.reason,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('撤销成功')
          this.get_lis()
          this.is_revocation = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    show_details(row) {
      const modal = modalMap[row.procDefKey]
      this.$refs[modal].show({
        businessKey: row.buId,
        procInstId: row.procInstId,
        procDefKey: row.procDefKey,
        recordNumber: 1,
      })
    },
  },
}
</script>
